import React from 'react';
import Swal from "sweetalert2";
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const EditProvider = (props) => {
    const submitProviderUpdates = (provider) => {
        provider.assets = [];
        AdminInterface.instance.updateProvider(provider).then(() => {
            Swal.fire('Updated!', '', 'success')
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: [error.response?.data?.detail.map((detail) => detail.msg)],
            });
        })
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>Edit Provider</CardTitle>
                </CardTitleWrap>
                <Form onSubmit={submitProviderUpdates} initialValues={props.selectedProvider}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="name" component="input" type="text" placeholder="Name" />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Description</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="description" component="input" type="text" placeholder="Description" />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>URL</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="url" component="input" placeholder="URL" />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={() => props.setSelectedProvider(null)}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>
            </CardBody>
        </Card>
    );
};

export default EditProvider;